<div class="tooltip-content">
  <!-- <div class="tooltip-header">

    <button (click)="downloadTrendReport(data.employees)" class="mr-10 Download fs-16 font_semibold">
      <img src="././assets/icon/yellowdownload.png" class="downIcon">Download
    </button>

    <div class="close_bg cp" [mat-dialog-close]>
      <img src="././assets/icon/close_icon.png" class="closeHeight">
    </div>
  </div> -->
  <ion-col size="12" size-md="6">
    <div class="d-flex ion-align-items-center flex-wrap"
         style="justify-content: flex-end; padding-right: 20px;">
  
      <!-- Refresh Icon -->
      <span
        class="material-icons btn-reset fs-22 mr-10 icon-action"
        style="cursor:pointer;"
        title="Refresh"
        [class.clicked]="isClicked"
        (click)="resetGrid(); isClicked = true"
        (animationend)="isClicked = false">
        refresh
      </span>
  
      <!-- Download Icon -->
      <span class="icon-download fs-20 material-icons cursor-pointer"
        style="cursor: pointer; margin-right: 10px;"
        (click)="onBtExport()">
        download
      </span>
  
      <!-- Close Icon -->
      <span [mat-dialog-close]
        class="fs-30 fs_24ForMobile material-icons icon-close"
        style="cursor: pointer;">
        close
      </span>
  
    </div>
  </ion-col>
  
  
  <div class="tooltip-scroll">
    
    <!-- <table class="custom-table">
      <thead>
        <tr>
          <th>Employee Name</th>
          <th>Department</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let emp of data.employees">
          <td>{{ emp.employeeName }}</td>
          <td>
            <span class="dept-style" [style.color]="emp.departmentColor">
              {{ emp.department }}
            </span>
          </td>
        </tr>
      </tbody>
    </table> -->
    <mat-sidenav-container style="height: 320px; width: 100%;">
      <mat-sidenav-content>
        <ag-grid-angular
          class="ag-theme-quartz"
          style="width: 100%; height: 320px;"
          [rowData]="rowData"
          [columnDefs]="columnDefs"
          [gridOptions]="gridOptions"
          [defaultColDef]="defaultColDef"
          (gridReady)="onGridReady($event)"
          (rowClicked)="onRowClicked($event)"
          [pagination]="pagination"
          [paginationPageSize]="paginationPageSize"
          [paginationPageSizeSelector]="paginationPageSizeSelector"
        >
        </ag-grid-angular>
      </mat-sidenav-content>
    </mat-sidenav-container>
    

  </div>
</div>